<m4w-layout></m4w-layout>
<m4w-upgrade-dialog></m4w-upgrade-dialog>

<p-toast
  position="bottom-center"
  [showTransitionOptions]="'250ms'"
  [showTransformOptions]="'translateY(100%)'"
  [hideTransitionOptions]="'150ms'"
  [hideTransformOptions]="'translateY(100%)'"
  [breakpoints]="{ '576px': { width: '95vw' } }"
/>
